module.exports = "/_next/static/images/marketingAutomationImage2x-00291947389ac128ed12d02ac3d9a056.jpg.webp";